import gql from 'graphql-tag';

export default gql`
subscription {
    onDeleteProvider {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Providers/DeleteSubscription.js